import { type INotification } from '@/types/INotification';
import { isOrderNotification } from '@/utils/isOrderNotification';
import { OrderNotificationItem } from '../OrderNotificationItem/OrderNotificationItem';

interface INotificationItemProps {
  notification: INotification;
  onSelect: (path: string, id: string) => void;
}

/**
 * Диспетчер карточки уведомления по типу — реестр рендереров. Новый тип
 * уведомления добавляется новой веткой здесь и своим компонентом-карточкой,
 * без изменения панели и колокольчика.
 */
export const NotificationItem: React.FC<INotificationItemProps> = ({
  notification,
  onSelect
}) => {
  if (isOrderNotification(notification)) {
    return (
      <OrderNotificationItem notification={notification} onSelect={onSelect} />
    );
  }

  return null;
};
